import React from 'react';

const ShieldIcon = ({ className = "" }) => {
  return (
    <svg 
      viewBox="0 0 100 100" 
      className={`${className}`}
      style={{ width: '20px', height: 'auto' }}
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="redGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF4444" />
          <stop offset="100%" stopColor="#CC0000" />
        </linearGradient>
        <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4444FF" />
          <stop offset="100%" stopColor="#0066CC" />
        </linearGradient>
      </defs>
      
      {/* Shield outline */}
      <path
        d="M50 5 L20 20 L20 50 Q20 80 50 95 Q80 80 80 50 L80 20 Z"
        stroke="#333"
        strokeWidth="2"
        fill="none"
      />
      
      {/* Red half */}
      <path
        d="M50 7 L22 21 L22 50 Q22 77 50 92 L50 7 Z"
        fill="url(#redGradient)"
      />
      
      {/* Blue half */}
      <path
        d="M50 7 L78 21 L78 50 Q78 77 50 92 L50 7 Z"
        fill="url(#blueGradient)"
      />
      
      {/* Inner highlight */}
      <path
        d="M50 10 L25 23 L25 48 Q25 72 50 85 Q75 72 75 48 L75 23 Z"
        stroke="rgba(255,255,255,0.3)"
        strokeWidth="1"
        fill="none"
      />
    </svg>
  );
};

export default ShieldIcon;